angular.module("downloadDossierCerved.components", [])
    .component("downloadDossierCerved", {
        templateUrl: 'ng/components/downloadDossierCerved/downloadDossierCerved.view.html',
        bindings: {},
        controller: DownloadDossierCervedController,
        controllerAs: 'downloadDossierCervedCtrl'
    })

function DownloadDossierCervedController(
    $simulationService
) {
    var self = this;

    self.$onInit = function () {
        self.mode = {
            cf: null
        }

    }

    self.downloadDossier = function () {
        self.loader = true;
        $simulationService.downloadDossierCerved(self.model.cf)
            .then(function (response) {
                console.log(response);
                self.loader = false;
                self.model.cf = null;
            })
            .catch(function (error) {
                console.log(error);
                self.loader = false;
                self.model.cf = null;
            })
    }
}